import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#667eea',
        secondary: '#764ba2',
        accent: '#4ade80',
        error: '#f87171',
        warning: '#fbbf24',
        info: '#60a5fa',
        success: '#4ade80',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});

